/**
 * Infinite Scroll for Shopify Collections
 * Automatically loads next page when user scrolls to bottom
 */

class InfiniteScroll {
  constructor() {
    this.container = document.querySelector('.collection-products');
    this.pagination = document.querySelector('.collection-pagination');
    this.loading = false;
    this.hasMore = true;
    
    if (!this.container || !this.pagination) return;
    
    this.init();
  }
  
  init() {
    // Hide original pagination
    this.pagination.style.display = 'none';
    
    // Create loading indicator
    this.createLoader();
    
    // Setup intersection observer
    this.setupObserver();
    
    // Check if there's a next page
    this.checkNextPage();
  }
  
  createLoader() {
    this.loader = document.createElement('div');
    this.loader.className = 'infinite-scroll-loader';
    this.loader.innerHTML = `
      <div class="loader-spinner">
        <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
          <circle cx="20" cy="20" r="18" fill="none" stroke="#000" stroke-width="2" stroke-dasharray="90, 150" stroke-linecap="round">
            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 20 20;360 20 20" keyTimes="0;1"/>
          </circle>
        </svg>
        <p>Carregando mais produtos...</p>
      </div>
    `;
    this.loader.style.display = 'none';
    this.container.parentElement.appendChild(this.loader);
  }
  
  setupObserver() {
    const options = {
      root: null,
      rootMargin: '400px', // Start loading 400px before reaching the end
      threshold: 0
    };
    
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.loading && this.hasMore) {
          this.loadNextPage();
        }
      });
    }, options);
    
    // Create a sentinel element to observe
    this.sentinel = document.createElement('div');
    this.sentinel.className = 'infinite-scroll-sentinel';
    this.sentinel.style.height = '1px';
    this.container.parentElement.appendChild(this.sentinel);
    this.observer.observe(this.sentinel);
  }
  
  checkNextPage() {
    // Check if there's a "next" link in pagination
    const nextLink = this.pagination.querySelector('a[rel="next"], .next a, a.next');
    
    if (!nextLink) {
      this.hasMore = false;
      this.showEndMessage();
    } else {
      this.nextPageUrl = nextLink.href;
    }
  }
  
  async loadNextPage() {
    if (this.loading || !this.hasMore || !this.nextPageUrl) return;
    
    this.loading = true;
    this.loader.style.display = 'block';
    
    try {
      const response = await fetch(this.nextPageUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Get new products
      const newProducts = doc.querySelectorAll('.collection-products .product');
      
      if (newProducts.length === 0) {
        this.hasMore = false;
        this.showEndMessage();
        return;
      }
      
      // Append new products with fade-in animation
      newProducts.forEach((product, index) => {
        const clone = product.cloneNode(true);
        clone.style.opacity = '0';
        clone.style.transform = 'translateY(20px)';
        this.container.appendChild(clone);
        
        // Animate in
        setTimeout(() => {
          clone.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
          clone.style.opacity = '1';
          clone.style.transform = 'translateY(0)';
        }, index * 50);
      });
      
      // Update pagination and check for next page
      const newPagination = doc.querySelector('.collection-pagination');
      if (newPagination) {
        this.pagination.innerHTML = newPagination.innerHTML;
        this.checkNextPage();
      } else {
        this.hasMore = false;
        this.showEndMessage();
      }
      
      // Update URL without reload
      if (window.history && window.history.pushState) {
        window.history.pushState({}, '', this.nextPageUrl);
      }
      
    } catch (error) {
      console.error('Error loading next page:', error);
      this.showErrorMessage();
    } finally {
      this.loading = false;
      this.loader.style.display = 'none';
    }
  }
  
  showEndMessage() {
    this.loader.innerHTML = `
      <div class="infinite-scroll-end">
        <p>Você viu todos os produtos!</p>
      </div>
    `;
    this.loader.style.display = 'block';
    
    // Remove observer
    if (this.observer && this.sentinel) {
      this.observer.unobserve(this.sentinel);
    }
  }
  
  showErrorMessage() {
    const errorMsg = document.createElement('div');
    errorMsg.className = 'infinite-scroll-error';
    errorMsg.innerHTML = `
      <p>Erro ao carregar produtos. <button onclick="location.reload()">Tentar novamente</button></p>
    `;
    this.loader.appendChild(errorMsg);
  }
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new InfiniteScroll();
  });
} else {
  new InfiniteScroll();
}
